module.exports = __webpack_public_path__ + "img/bus-partner-img6.75227b98.png";